<div class="bookmarks-container">
  <app-sidenav-header title="{{'BOOKMARKS.BOOKMARKS' | transloco }}" 
    subtitle="{{'BOOKMARKS.BOOKMARKED' | transloco }}"></app-sidenav-header>
  <ng-container *ngFor="let bookmark of bookmarkList">
    <div class="table-tr mb-16 cursor-pointer" (click)="rowClick(bookmark)">
      <div class="flex flex-col endpoint-row mb-8">
        <div class="flex justify-between items-center row-content p-16 mat-subtitle-2 mb-0">
          <div class="bookmark-name">
            <span class="fw-600" [title]="bookmark.name">{{bookmark.name}}</span>
          </div>
          <div>
            <span class="fw-400">{{'BOOKMARKS.LAST_UPDATED' | transloco}}: </span>
            <span class="fw-400">{{dateTimeFormatService.getUtcFromat(bookmark.dateUpdated)}}</span>
          </div>
          <div class="bookmark-type pl-10 pr-10 pt-2 pb-2 fw-500 fs-12">
            {{'INSTANCE_DETAILS.INSTANCE' | transloco}}
          </div>
          <div (click)="deleteClick(bookmark)">
            <mat-icon svgIcon="delete" class="icon-md-1 mr-12"></mat-icon>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
</div>
